export const nameofT = <T>(propName: keyof T) => propName
export const nameof = <T>(obj: T, propName: keyof T) => propName
export const nameofFactory =
  <T>() =>
  (name: keyof T) =>
    name

const type = {
  nameof,
  nameofFactory,
  nameofT,
}

export default type
